import {Component} from 'react';
import {Container, Icon, Popup} from 'semantic-ui-react';

export default class SellersReservePriceTip extends Component {
  render() {
    return (
      <Popup on="click" wide
             position="right center"
             trigger={<Icon name="help circle outline" link/>}>
        <Container fluid>
          <p>
            For auctions and fixed-date sales agents will need to:
          </p>
          <ul>
            <li>
              have the seller's reserve price confirmed in writing, as a single dollar
              figure (not a range)
            </li>
            <li>
              publish the reserve price at least <strong>7 days</strong> before the auction
              or fixed-date sale
            </li>
            <li>
              update all marketing materials to reflect the reserve price once it is set,
              and withdraw outdated advertising immediately.
            </li>
          </ul>
          <p>
            An auction or fixed-date sale will not be able to proceed unless the reserve
            price has been published for the full 7-day period.
          </p>
        </Container>
      </Popup>
    );
  }
}
